import React, { useMemo } from 'react';
import { Widget, Table, ColumnProps } from '@digital/ui';
import { ReportCapexManeger, ReportCapexManegerDiretoria } from '@app/api/relatorios';
import Barra from './barra';

interface capexManagementProps {
  data: ReportCapexManeger;
}

const CapexManagement = (props: capexManagementProps) => {
  const { data } = props;

  const colluns = useMemo(() => {
    const col: ColumnProps<ReportCapexManegerDiretoria>[] = [
      {
        title: 'Diretoria',
        dataIndex: 'sigla',
      },
      {
        title: 'ORÇADO - R$ M',
        children: [
          {
            title: 'A - ORÇADO',
            children: [
              {
                title: `${data.totalizadorOrcado}`,
                dataIndex: 'orcadoFormat',
              },
            ],
          },
          {
            title: 'B - Contratado',
            children: [
              {
                title: `${data.totalizadorContratado}`,
                dataIndex: 'contratadoFormat',
              },
            ],
          },
          {
            title: 'C - REQUISITADO',
            children: [
              {
                title: `${data.totalizadorRequistiado}`,
                dataIndex: 'requistiadoFormat',
              },
            ],
          },
          {
            title: 'D - EXECUTADO',
            children: [
              {
                title: `${data.totalizadorExecutado}`,
                dataIndex: 'executadoFormat',
              },
            ],
          },
          {
            title: 'E - FORECAST',
            children: [
              {
                title: `${data.totalizadorForcast}`,
                dataIndex: 'forcastFormat',
              },
            ],
          },
        ],
      },
      {
        title: '% (B + C) / A',
        children: [
          {
            render: (index, record) => {
              return <Barra percentual={record.collunBMaisCDivididoPorA} strokeColor={'#8C0400'} />;
            },
          },
          {
            title: '%',
            render: (index, record) => {
              return `${record.collunBMaisCDivididoPorA} %`;
            },
          },
        ],
      },
      {
        title: '% EXECUTED (D / A)',
        children: [
          {
            render: (index, record) => {
              return <Barra percentual={record.collunBMaisCDivididoPorA} strokeColor={'#80BDA6'} />;
            },
          },
          {
            title: '%',
            render: (index, record) => {
              return `${record.collunDDivididoPorA} %`;
            },
          },
        ],
      },
      {
        title: 'ADER',
        render: (index, record) => {
          return `${record.ader} %`;
        },
      },
      {
        title: 'NÃO PREVISTO (QUANTIDADE)',
        children: [
          {
            title: `${data.totalizadorNaoPrevisto}`,
            dataIndex: 'naoPrevisto',
          },
        ],
      },
    ];

    return col;
  }, [data]);

  return (
    <Widget title="CONTROLE POR DIRETORIA" span={12} actions={[]}>
      <Table
        columns={colluns}
        dataSource={data.listReportCapexManegerDiretoria}
        className="executive-summary-table"
        pagination={false}
      />
    </Widget>
  );
};

export default CapexManagement;
